import { Types } from "../../context/action/action";
import store from "../../context/store/store";
import { UserDetails, contactSync } from "../../models/model";
import {config} from '../constant';
import { v4 as uuidv4 } from 'uuid';
import {contactService} from '../contactService';
import { getCookie } from "../utils";
import { createCallConnection } from "../callService/callService";
import { AuthService } from "../authService/auth.service";
import { determineIps } from "../callService/common";
export class LoginService {
  public static async updateLoginDetails(loginDetails: UserDetails) {
    store.dispatch({
      type: Types.ADD_LOGIN,
      payload: {
        userdetails:loginDetails
      }
    });
  }
  public static async forgotPassword(data:any) {
    return AuthService.forgotPassword(data).then((value:any)=>{
      return value;
    }).catch(()=>{
      console.log("API Error");
    });
  }
  public static async getCurrentUser(history:any){
    let self = this;
    return AuthService.getCurrentUser()
      .then((data: any) => {
        if (data['status_code'] === 200) {
          self?.updateLoginDetails(data.user_info);
          
        } else if(data['status_code']===401){
          history.push('/login');
        }
        return data;
      })
      .catch((err:any) => {
        console.log(err, 'get user error');
        return false;
      });
  }

  public static async reInitUser(){
    let self = this;
    return AuthService.getCurrentUser()
      .then((data: any) => {
        if (data['status_code'] === 200) {
          self?.updateLoginDetails(data.user_info);
          
        } else if(data['status_code']===401){
         
        }
        return data;
      })
      .catch((err:any) => {
        console.log(err, 'reInitUser');
        return false;
      });
  }
  

  public static async createSSOToken(data:any) {
    const appId= config().APPID;
    const appSecret = config().AppSECRET;
    return AuthService.createSSOToken(data,{ appId,appSecret}).then((value)=>{
      localStorage.setItem('authorization',value.token);
      return value;
    })
  }

  /** After discusion, it was commented(Need to verify)
   */
  // public static async getUserdata(tokenifo: any) {
  //   tokenifo.baseUrl = config().CHAT_RESTAPI_URL;  
  //   restAPIChat.getUserdata(tokenifo).then(async(response: any) => {
  //     if (response.statusCode === 200) {
  //       store.dispatch({
  //         type: Types.ADD_LOGIN,
  //         payload: {
  //           userdetails: response.user_info
  //         }
  //       });
  //       //expDays in days
  //       setCookie('userinfo', JSON.stringify(response.user_info), 1);

  //       setCookie('token', tokenifo.token, 1);
      
  //       const queryParams:contactSync = { ext: response.user_info.ext, CallId: uuidv4()};
  //       await contactService.getWorkcontact(queryParams);
  //       createCallConnection(response.user_info);
  //     }
  //   });

  // }



  public static async createConnections(userInfo: any) {

    //XMPP.urXMPPdisconnect();
    let token: any = getCookie('ssoToken');
    localStorage.setItem('authorization', token);
    store.dispatch({
      type: Types.ADD_TOKEN,
      payload: {
        token: token
      }
    });
   // contactService.getTeamContact();
    const queryParams:contactSync = { ext:userInfo.ext, CallId: uuidv4()};
    await contactService.getWorkcontact(queryParams);
    //const chatSocket = new SocketChatService(userInfo.sip_login_id, userInfo.domain_id);
    let ipDetails:any= await determineIps();
    if(ipDetails?.IP){
      createCallConnection(userInfo,ipDetails.IP);
    }


  }

}